module.exports = __webpack_public_path__ + "static/img/060_TO8_1614_og.81585db.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/060_TO8_1614_og.jpg
// module id = 0f9d
// module chunks = 0